import React, { useId, useState } from 'react';
import './App.css';

export default function ReadMore({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  // Turn children into an array so we can split off the first element
  const items = React.Children.toArray(children);
  const first = items[0];
  const rest  = items.slice(1);

  return (
    <div className="read-more">
      {/* Always-visible first bit */}
      {first}

      {/* Collapse/expand the rest */}
      {rest.length > 0 && (
        <>
          {/* max-height:0 hides this visually but leaves it in the accessibility
              tree and the tab order. inert takes it out of both, and unlike
              hidden/display:none it leaves the max-height transition intact. */}
          <div
            id={panelId}
            className={`content-wrapper ${isOpen ? 'open' : 'collapsed'}`}
            inert={!isOpen}
          >
            {rest}
          </div>
          <button
            type="button"
            className="read-more-toggle"
            aria-expanded={isOpen}
            aria-controls={panelId}
            onClick={() => setIsOpen(o => !o)}
          >
            {isOpen ? 'See less' : 'See more'}
          </button>
        </>
      )}
    </div>
  );
}
